module.exports = __webpack_public_path__ + "static/media/used-car-banner.79c9a1e3.jpg";